import styled from 'styled-components'
import logoJpg from 'assets/logo.png'

const Logo = styled.img.attrs({
  src: logoJpg,
  alt: 'Lamp Studio',
})``

export default Logo
